import { useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

import { trackNavigation } from "@/lib/sentryBreadcrumbs";

/**
 * Hook to automatically track navigation breadcrumbs
 */
export const useSentryNavigation = () => {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      trackNavigation(prevLocation.current, location.pathname);
      prevLocation.current = location.pathname;
    }
  }, [location]);
};

/**
 * Hook to track component lifecycle for debugging
 */
export const useSentryComponentTracking = (componentName: string, data?: Record<string, any>) => {
  useEffect(() => {
    // Track component mount
    console.debug(`[Sentry] ${componentName} mounted`, data);

    return () => {
      // Track component unmount
      console.debug(`[Sentry] ${componentName} unmounted`);
    };
  }, [componentName]);
};
